module.exports = __webpack_public_path__ + "img/order5.64dead2e.png";